(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ra-catalog-tools"] && !Shopify.designMode) return;
  try {
    function initializeRugCatalog(root) {
  root.querySelectorAll('[data-rug-catalog]').forEach(catalog => {
    const controls = catalog.querySelector('[data-local-filters]');
    if (!controls || catalog.dataset.filtersReady) return;
    catalog.dataset.filtersReady = 'true';
    const cards = Array.from(catalog.querySelectorAll('[data-rug-variants]')).map(element => ({element, variants: JSON.parse(element.dataset.rugVariants)}));
    const size = controls.querySelector('[data-local-size]');
    const min = controls.querySelector('[data-local-min]');
    const max = controls.querySelector('[data-local-max]');
    const count = catalog.querySelector('[data-local-count]');
    const empty = catalog.querySelector('[data-local-empty]');
    const sizes = [...new Set(cards.flatMap(card => card.variants.filter(variant => variant.available).map(variant => variant.size)).filter(Boolean))].sort((a,b) => a.localeCompare(b, undefined, {numeric:true}));
    sizes.forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; size.append(option); });
    controls.querySelector('[data-size-field]').hidden = sizes.length === 0;
    const initial = new URL(window.location.href).searchParams;
    if (sizes.includes(initial.get('ra_size'))) size.value = initial.get('ra_size');
    for (const [input,key] of [[min,'ra_min'],[max,'ra_max']]) { const value=initial.get(key); if(value !== null && value !== '' && Number.isFinite(Number(value)) && Number(value)>=0) input.value=value; }
    function filterCards(updateUrl=true) {
      const low = min.value === '' ? 0 : Math.round(Number(min.value)*100);
      const high = max.value === '' ? Infinity : Math.round(Number(max.value)*100);
      let visible = 0;
      cards.forEach(card => { const matches=card.variants.some(v => v.available && (!size.value || v.size===size.value) && v.price>=low && v.price<=high); card.element.hidden=!matches; if(matches)visible++; });
      count.textContent = visible + ' ' + count.dataset.countLabel;
      empty.hidden = visible > 0;
      if(updateUrl) { const url=new URL(window.location.href); for(const [input,key] of [[size,'ra_size'],[min,'ra_min'],[max,'ra_max']]) { if(input.value)url.searchParams.set(key,input.value);else url.searchParams.delete(key); } history.replaceState({},'',url); }
    }
    [size,min,max].forEach(input => input.addEventListener('input',() => filterCards()));
    controls.querySelector('[data-local-reset]').addEventListener('click',() => {size.value='';min.value='';max.value='';filterCards();});
    catalog.querySelector('.catalog-form')?.addEventListener('submit',event => {
      for(const [input,key] of [[size,'ra_size'],[min,'ra_min'],[max,'ra_max']]) { let hidden=event.target.querySelector('[name="'+key+'"]'); if(!hidden){hidden=document.createElement('input');hidden.type='hidden';hidden.name=key;event.target.append(hidden);} hidden.value=input.value; }
    });
    window.addEventListener('popstate',() => {const query=new URL(window.location.href).searchParams;size.value=query.get('ra_size')||'';min.value=query.get('ra_min')||'';max.value=query.get('ra_max')||'';filterCards(false);});
    controls.hidden=false;count.hidden=false;filterCards(false);
  });
}
initializeRugCatalog(document);
document.addEventListener('shopify:section:load',event=>initializeRugCatalog(event.target));
  } catch(e) { console.error(e); }
})();

})();
